import { render } from "./AdminViewPendingRequest.vue?vue&type=template&id=6645c8e4"
import script from "./AdminViewPendingRequest.vue?vue&type=script&lang=js"
export * from "./AdminViewPendingRequest.vue?vue&type=script&lang=js"

import "./AdminViewPendingRequest.vue?vue&type=style&index=0&id=6645c8e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__